import {Directive, Input, NgModule} from '@angular/core';

@Directive({
  selector: '[sdBadge]',
  standalone: true,
  host: {
    class: 'sd-badge-host relative',
    '[attr.data-badge]': 'sdBadge',
  },
})
export class SdBadge {
  @Input() sdBadge: string | number | null | undefined;
  @Input() sdBadgeColor: string | undefined;
  @Input() sdBadgeSize: string | undefined;
  @Input() sdBadgeHidden = false;
  @Input() sdBadgeOverlap = true;
  @Input() sdBadgePosition: string | undefined;
}

@NgModule({
  imports: [SdBadge],
  exports: [SdBadge],
})
export class SdBadgeModule {}
